import { render, staticRenderFns } from "./Descuentos.vue?vue&type=template&id=3c99ef97&scoped=true"
import script from "./Descuentos.vue?vue&type=script&lang=js"
export * from "./Descuentos.vue?vue&type=script&lang=js"
import style0 from "./Descuentos.vue?vue&type=style&index=0&id=3c99ef97&prod&scoped=true&lang=css"
import style1 from "./Descuentos.vue?vue&type=style&index=1&id=3c99ef97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c99ef97",
  null
  
)

export default component.exports